// Client lib imports
const businessEvents = require('client/lib/business-events')
const globalPageContext = require('client/lib/business-events/page-context')
// Client V2 common imports
const { render } = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory
const suSubmitModalActions = require('client-v2/logged-out-landing/containers/su-submit-modal/actions')

render(configureStore, rootFactory)

globalPageContext.setPageContext({
  pageName: 'stream.profile'
})

businessEvents.trackInternal('pageview')
businessEvents.trackSegment('pageview')

app.store.dispatch(suSubmitModalActions.maybeOpen())
